
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.75 8A7.749 7.749 0 008 .25 7.749 7.749 0 00.25 8 7.749 7.749 0 008 15.75 7.749 7.749 0 0015.75 8zm-9.784 3.8a.375.375 0 01-.532 0L4.2 10.562a.375.375 0 010-.53L6.25 8 4.2 5.966a.375.375 0 010-.532L5.437 4.2a.375.375 0 01.532 0L8 6.25l2.034-2.05a.375.375 0 01.532 0l1.237 1.237a.375.375 0 010 .532L9.75 8l2.05 2.034a.375.375 0 010 .532l-1.238 1.237a.375.375 0 01-.53 0L8 9.75 5.966 11.8z"}})])
          )
        }
      }
    